import { configureStore } from '@reduxjs/toolkit'
import {
  themeReducer,
  tokenReducer,
  userReducer,
  conversionReducer,
  jwtReducer,
  userLoadingReducer,
  isCookieConsentOpenReducer,
} from './slices';

const store = configureStore({
  reducer: {
    theme: themeReducer,
    token: tokenReducer,
    user: userReducer,
    conversion: conversionReducer,
    jwt: jwtReducer,
    userLoading: userLoadingReducer,
    isCookieConsentOpen: isCookieConsentOpenReducer,
  }
})

export default store;